export default __webpack_public_path__ + "static/media/bar-chart-blue.3c647ef1.svg";